/**
 * Builds the brandMatchReasons entries from customer matches enriched by the
 * consolidated getCustomerMatches response (matchScore and matchReasons per match).
 * Matches the shape produced by the separate getMatchReasons saga.
 *
 * @param {Array} customerMatches - Enriched customer matches from the gateway
 * @returns {Array} brandMatchReasons entries ({ brandId, reasons, generationType, matchScore })
 */
const buildBrandMatchReasons = (customerMatches) =>
  customerMatches
    .filter((match) => match.brandId)
    .map((match) => {
      const reasons = match.matchReasons || '';
      const matchScore =
        typeof match.matchScore === 'number' &&
        Number.isFinite(match.matchScore)
          ? match.matchScore
          : null;

      return {
        brandId: match.brandId,
        reasons,
        generationType: reasons.length > 0 ? 'AI' : 'FALLBACK_WHAT_OTHERS_LIKE',
        matchScore,
      };
    });

export default buildBrandMatchReasons;
